/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ImportSourceFormat = {
    Canonical: 'Canonical',
    Jku: 'Jku'
} as const;
export type ImportSourceFormat = typeof ImportSourceFormat[keyof typeof ImportSourceFormat];

